import { createBrowserRouter } from "react-router-dom";
import { AuthGuard } from "../components/AuthGuard";
import { Layout } from "../components/Layout";
import { Dashboard } from "../pages/Dashboard";
import { OrganizationList } from "../pages/OrganizationList";
import { OrganizationDetail } from "../pages/OrganizationDetail";
import { Waitlist } from "../pages/Waitlist";

export const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <AuthGuard>
        <Layout />
      </AuthGuard>
    ),
    children: [
      {
        index: true,
        element: <Dashboard />,
      },
      {
        path: "organizations",
        element: <OrganizationList />,
      },
      {
        path: "organizations/:id",
        element: <OrganizationDetail />,
      },
      {
        path: "waitlist",
        element: <Waitlist />,
      },
    ],
  },
]);
